import React, { useState } from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { cilUser } from '@coreui/icons'

import {
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CRow,
  CForm,
  CInputGroup,
  CInputGroupText,
  CFormInput,
  CButton,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { HeaderComponent } from './HeaderComponent'

const SeleccionarCuentasPage = ({}) => {
  const [inputs, setInputs] = useState('')

  const navigate = useNavigate()

  return (
    <div className="min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <HeaderComponent title="Pago Online" />
                  <CForm>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="RUT o Código Cuentas"
                        autoComplete="cuentas"
                        value={inputs}
                        onChange={(e) => setInputs(e.target.value)}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol>
                        <div className="d-grid gap-2">
                          <CButton
                            color="primary"
                            className="px-4"
                            onClick={(e) => {
                              navigate({
                                pathname: '/pagar-cuotas',
                                search: `?${createSearchParams({ cuentas: inputs })}`,
                              })
                            }}
                          >
                            Ver cuotas
                          </CButton>
                        </div>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
        {/* <CRow className="justify-content-center mt-2">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-1">
                <CCardBody>
                  <CRow>
                    <CCol className="text-center">
                      <div className="d-grid gap-2 mt-1">
                        <CButton
                          color="primary"
                          className="px-4"
                          onClick={() => {
                            navigate({
                              pathname: '/',
                            })
                          }}
                        >
                          Ir al menú principal
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow> */}
      </CContainer>
    </div>
  )
}

export default SeleccionarCuentasPage
